import React from 'react';
import Titulo from '@/components/tipografia/Titulo';
import Descricao from '@/components/tipografia/Descricao';
import HBox from './HBox';
import VBox from './VBox';
import useWindowSize from '@/lib/useWindowSize';

type PageHeaderProps = {
    title: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    containerStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    actionsStyle?: React.CSSProperties;
};

const PageHeader = ({
    title,
    description,
    actions,
    containerStyle,
    contentStyle,
    actionsStyle,
}: Readonly<PageHeaderProps>) => {
    const [, , isMobile] = useWindowSize();

    return (
        <HBox
            style={{
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: '12px',
                flexWrap: isMobile ? 'wrap' : 'nowrap',
                ...(containerStyle ?? {}),
            }}
        >
            <VBox
                style={{
                    flex: 1,
                    width: isMobile ? '100%' : undefined,
                    minWidth: 0,
                    ...(contentStyle ?? {}),
                }}
            >
                <Titulo>{title}</Titulo>
                {description ? <Descricao>{description}</Descricao> : null}
            </VBox>

            {actions ? (
                <HBox
                    style={{
                        gap: '8px',
                        flexShrink: 0,
                        alignItems: 'center',
                        width: isMobile ? '100%' : 'auto',
                        flexWrap: isMobile ? 'wrap' : 'nowrap',
                        justifyContent: 'flex-start',
                        ...(actionsStyle ?? {}),
                    }}
                >
                    {actions}
                </HBox>
            ) : null}
        </HBox>
    );
};

export default PageHeader;